exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.blance-bgc[data-v-2e7eb1c7] {\n  background-color: #f3f3f1;\n}\n.blance-padding[data-v-2e7eb1c7] {\n  padding: 15px 0 10px;\n}\n", ""]);

// exports
